module.exports = __webpack_public_path__ + "img/donna.bca64977.png";